import { getDocument } from './getDocument.js';

/**
 * Returns `element.ownerDocument.defaultView || window`.
 */

function getDefaultView(element) {
  return getDocument(element).defaultView || window;
}

export { getDefaultView };
